export type TimeRange = 'today' | 'last_7_days' | 'last_30_days';

export type RedditPostType = 'text' | 'visual';

export type PostType = RedditPostType | 'all';

export const RedditPostsOrderBy = {
  UpvotesCount: 'upvotes_count',
  CommentsCount: 'comments_count',
  PostedAt: 'posted_at',
  TrendScore: 'trend_score',
} as const;

export type RedditPostsOrderBy = (typeof RedditPostsOrderBy)[keyof typeof RedditPostsOrderBy];

export type SortBy = RedditPostsOrderBy;

export const RedditTones = [
  'Accountability',
  'Productivity',
  'Nutrition',
  'Motivation',
  'Process',
  'Mindset',
  'Transformation',
  'Community',
  'Health',
  'Emotional',
] as const;

export type RedditTone = (typeof RedditTones)[number];

export interface RedditKeyword {
  id: number;
  phrase: string;
}

export interface RedditComment {
  reddit_id: string;
  author: string;
  body: string;
  url: string;
  upvotes_count: number;
  commented_at: string;
}

export interface RedditPost {
  reddit_id: string;
  subreddit: string;
  author: string;
  title: string;
  body: string;
  url: string;
  summary: string;
  upvotes_count: number;
  comments_count: number;
  posted_at: string;
  trend_score: number;
  is_trending: boolean;
  post_type: RedditPostType;
  pain_point: string[];
  tone: RedditTone | null;
  hook_ideas: string[];
  creative_scripts: string[];
  key_phrases: string[];
  keywords: RedditKeyword[];
  comments: RedditComment[];
}

export interface RedditPostsListResponse {
  data: RedditPost[];
  meta: {
    count: number;
    limit: number;
    offset: number;
    load_ts: string;
  };
}

export interface RedditKeywordsResponse {
  data: RedditKeyword[];
}

export interface GetRedditPostsParams {
  date_from: string;
  date_to: string;
  keyword_id?: number[];
  post_type?: RedditPostType;
  order_by?: RedditPostsOrderBy;
  desc?: boolean;
  limit?: number;
  /** Number of items to skip (0, limit, 2*limit, …) */
  offset?: number;
}
